import React, { useState, useEffect, useRef } from "react";
import "../../App.css";
import FAQSection from "../about/FAQSection";

// Contact Page Component
function ContactPage() {
  const [showEnquireModal, setShowEnquireModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [enquireData, setEnquireData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    requirements: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const openGoogleMaps = (address, event) => {
    // Prevent event bubbling to parent elements
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
  };

  const handleEnquireNow = () => {
    setShowEnquireModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEnquireChange = (e) => {
    const { name, value } = e.target;
    setEnquireData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');
    setSubmitSuccess(false);

    try {
      const requestData = {
        ...formData,
        to_email: 'ravi@geotechgeospatial.com',
        form_type: 'contact'
      };

      const response = await fetch('https://geotechgeospatial.com/send_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSubmitSuccess(true);
        setFormData({ name: '', email: '', message: '' });
        
        setTimeout(() => {
          setSubmitSuccess(false);
        }, 3000);
      } else {
        throw new Error(result.message || 'Failed to send message');
      }
    } catch (error) {
      setSubmitError('Failed to send message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEnquireSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');
    setSubmitSuccess(false);

    try {
      const requestData = {
        ...enquireData,
        to_email: 'ravi@geotechgeospatial.com',
        form_type: 'enquiry'
      };


      const response = await fetch('https://geotechgeospatial.com/send_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...enquireData,
          to_email: 'ravi@geotechgeospatial.com',
          form_type: 'enquiry'
        }),
      });

      
      const result = await response.json();

      if (response.ok && result.success) {
        setSubmitSuccess(true);
        setEnquireData({ name: '', email: '', phone: '', service: '', requirements: '' });
        setShowEnquireModal(false);
        
        setTimeout(() => {
          setSubmitSuccess(false);
        }, 3000);
      } else {
        throw new Error(result.message || 'Failed to submit enquiry');
      }
    } catch (error) {
      setSubmitError('Failed to submit enquiry. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page-modern">
      {/* Modern Contact Section */}
      <section className="contact-modern-section">
        <div className="contact-modern-container">
          {/* Left Side - Contact Info */}
          <div className="contact-info-side">
            <div className="contact-header-text">
              <h1 className="contact-modern-title">Contact Us</h1>
              <p className="contact-modern-subtitle">
                Reach out to us for inquiries, support, or partnership opportunities.
                We're here to help with all your geospatial needs.
              </p>
            </div>

          </div>

          {/* Right Side - Contact Form */}
          <div className="contact-form-side">
            <div className="contact-form-card">
              <h2 className="form-title">Send Message</h2>
              {submitSuccess && (
                <div className="success-message">
                  Message sent successfully! We'll get back to you soon.
                </div>
              )}
              {submitError && (
                <div className="error-message">
                  {submitError}
                </div>
              )}
              <form className="modern-contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input 
                    type="text" 
                    name="name"
                    placeholder="Full Name" 
                    required 
                    value={formData.name}
                    onChange={handleFormChange}
                  />
                </div>
                <div className="form-group">
                  <input 
                    type="email" 
                    name="email"
                    placeholder="Email" 
                    required 
                    value={formData.email}
                    onChange={handleFormChange}
                  />
                </div>
                <div className="form-group">
                  <textarea 
                    name="message"
                    rows="4" 
                    placeholder="Type your Message..." 
                    required
                    value={formData.message}
                    onChange={handleFormChange}
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="send-button" 
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Location Cards Section */}
      <section className="location-cards-section">
        <div className="section__container">

          <h1 className="Contact_heading">FIND US @</h1>

          <div className="locations-grid">
            {/* India Locations */}
            <div className="location-country">
              <h3 className="location-country__title">India</h3>

              <div className="location-card">
                <div className="location-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <div className="location-content">
                  <h4 className="location-title">REGISTERED OFFICE</h4>
                  <p
                    className="location-address clickable-address"
                    onClick={(e) => openGoogleMaps("7/170, 6th Street, Astalakshmi Nagar, Alapakkam, Chennai - 600 116, India", e)}
                    title="Click to open in Google Maps"
                  >
                    7/170, 6th Street, Astalakshmi Nagar, Alapakkam, Chennai - 600 116
                  </p>
                </div>
              </div>

              <div className="location-card">
                <div className="location-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <div className="location-content">
                  <h4 className="location-title">SALES OFFICE</h4>
                  <p
                    className="location-address clickable-address"
                    onClick={(e) => openGoogleMaps("NO.50/85, First Floor, Bazulla Road, T.Nagar, Chennai 600017, India", e)}
                    title="Click to open in Google Maps"
                  >
                    No.54/81, First Floor, Bazullah Road, T.Nagar, Chennai 600017.
                  </p>
                  <p className="location-contact">sales@geotechgeospatial.com</p>
                </div>
              </div>
            </div>

            {/* Singapore Location */}
            <div className="location-country">
              <h3 className="location-country__title">Singapore</h3>

              <div className="location-card">
                <div className="location-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <div className="location-content">
                  <h4 className="location-title">GEOTECH SG PTE.LTD</h4>
                  <p
                    className="location-address clickable-address"
                    onClick={(e) => openGoogleMaps("20, Collyer Quay, #09-01, Singapore - 049319", e)}
                    title="Click to open in Google Maps"
                  >
                    20, Collyer Quay, #09-01, Singapore - 049319
                  </p>
                </div>
              </div>
            </div>


            {/* Contact Information */}
            <div className="location-country">
              <div className="contact-info-card">
                <h4 className="contact-info-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                  Mail Us
                </h4>
                <p className="contact-info-detail">ravi@geotechgeospatial.com</p>
                <p className="contact-info-detail">geotech.indiasales@gmail.com</p>
              </div>

              <div className="contact-info-card">
                <h4 className="contact-info-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                  Call Us
                </h4>
                <p className="contact-info-detail">+91 98405 08463</p>
                <p className="contact-info-detail">91-44-28340094</p>
              </div>
            </div>
          </div>
          
          {/* FAQ Section - Full Width */}
          <div className="faq-full-width">
            <FAQSection />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;